import React from 'react'
import { Icon } from '@chakra-ui/icons'
import { FaDollarSign } from 'react-icons/fa6'
import { Button } from '@chakra-ui/react'
import { useDisclosure } from '@chakra-ui/react'

import {
    AppointmentFieldsFragment,
    ChatFieldsFragment,
} from '~graphql/generated/graphql'
import PaymentLinkModal from '~components/shared/payment-link-modal'
import IconButtonWithTooltip from '~components/shared/icon-button-with-tooltip'

interface Props {
    chat: ChatFieldsFragment
    text: string
    setText: (text: string) => void
    /** Appointment to attach, e.g. the one the chat was opened from. */
    appointment?: AppointmentFieldsFragment
    /** Force icon-only display regardless of breakpoint. */
    compact?: boolean
}

export default function RequestPaymentButton({
    chat,
    text,
    setText,
    appointment,
    compact = false,
}: Props) {
    const { isOpen, onOpen, onClose } = useDisclosure()

    if (!chat.clinic || !chat.client) return null

    return (
        <>
            <Button
                leftIcon={<Icon as={FaDollarSign} fontSize="xs" />}
                size="xs"
                borderWidth={1}
                borderColor="gray.200"
                h="28px"
                rounded="full"
                variant="subtle"
                onClick={onOpen}
                display={
                    compact
                        ? 'none'
                        : {
                              base: 'none',
                              lg: 'flex',
                          }
                }
            >
                Request payment
            </Button>
            <IconButtonWithTooltip
                icon={<Icon as={FaDollarSign} fontSize="xs" />}
                label="Request payment"
                size="xs"
                rounded="full"
                variant="subtle"
                borderWidth={1}
                borderColor="gray.200"
                tooltipOverrides={{
                    placement: 'top',
                }}
                display={
                    compact
                        ? 'flex'
                        : {
                              base: 'flex',
                              lg: 'none',
                          }
                }
                onClick={onOpen}
            />
            {isOpen && (
                <PaymentLinkModal
                    isOpen={isOpen}
                    onClose={onClose}
                    clientId={chat.client.id}
                    appointmentId={appointment?.id}
                    onCreated={url =>
                        setText(text ? `${text} ${url}` : url)
                    }
                />
            )}
        </>
    )
}
